import { RootState } from "src/store/types";

export const alertsSelector = (state: RootState) => state.alerts;
